// Apple Motion Art — web-sized loops transcoded from the masters.
// The site picks among them at random on every visit, so the ambience
// changes on its own — no server involved.
export const MOTION_ART = [
  "amar_nitai", "amayee", "ashibe_gelo_bondhu", "bombay", "bondhu_tin_din",
  "bridging_our_world", "eito", "fagunero_mohonay", "giri_puri", "im_wild",
  "im_wild_hindi", "intezaar", "kalo_jole", "kemono_chinibo", "komola_nritto_kore",
  "ma_aachen_aar", "majhi_baiya_jao_re", "mon_tore", "shob_kichhu_nau",
  "shri_krishna", "shundori_komola", "sohag_chand", "stardust", "tomar_ghore",
].map((n) => n);

export const randomMotionPair = () => {
  const a = MOTION_ART[Math.floor(Math.random() * MOTION_ART.length)];
  let b = MOTION_ART[Math.floor(Math.random() * MOTION_ART.length)];
  while (b === a) b = MOTION_ART[Math.floor(Math.random() * MOTION_ART.length)];
  return [a, b];
};

// release title -> motion art file, for hover-to-play covers
export const RELEASE_MOTION = {
  "Bombay": "bombay",
  "Shundori Komola": "shundori_komola",
  "Bondhu Tin Din": "bondhu_tin_din",
  "Kalo Jole": "kalo_jole",
  "Intezaar": "intezaar",
  "I'm Wild": "im_wild",
  "I'm Wild (Hindi Version)": "im_wild_hindi",
  "Ei Minoti": "ei_minoti",
  "Ashibe Gelo Bondhu": "ashibe_gelo_bondhu",
  "Shob Kichu Nau": "shob_kichhu_nau",
  "Ma Aachen Aar": "ma_aachen_aar",
  "Shri Krishna": "shri_krishna",
  "Mon Tore": "mon_tore",
  "Sohag Chand": "sohag_chand",
  "Majhi Baiya Jao Re": "majhi_baiya_jao_re",
  "Amar Nitai": "amar_nitai",
  "Kemono Chinibo": "kemono_chinibo",
  "Fagunero Mohonay": "fagunero_mohonay",
  "Komola Nritto Kore": "komola_nritto_kore",
  "Eito": "eito",
  "Amayee": "amayee",
  "Giri Puri": "giri_puri",
  "Tomar Ghore": "tomar_ghore",
  "Stardust": "stardust",
};
